import { base64Decode, readGlobalState } from '@controllers/AlgorandController'
import AlgorandNetwork from '@providers/AlgorandNetwork'

export const handleContractNameAlgo = async (provider: AlgorandNetwork, contractAdress: string[]): Promise<string> => {
    const algoProvider = provider.getDefaultProvider()

    const appInfo = await algoProvider.getApplicationByID(Number.parseInt(contractAdress[0])).do()
    const globalState = await readGlobalState(algoProvider, appInfo.id)

    const assetName = globalState['AN'] as string // string
    return base64Decode(assetName)
}
